var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"games"},[_c('games-icon',{staticClass:"games__icon"}),_c('h2',{staticClass:"games__title"},[_vm._v(" Games hosted by me ")])],1),_c('div',{staticClass:"summary-games-table"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.getGames && _vm.getGames.length > 0
                    ? _vm.getGames.slice(0, 3)
                    : null,"cell-style":'display: grid; grid-template-columns: 3fr 2fr 2fr 2fr 0.7fr; grid-template-rows: 4rem;',"data-elements":[
                'name',
                'currentPlayers',
                'allServersCount',
                'scenarioEarning',
            ],"cropp":true,"cropp-no":10,"footer-elements":_vm.getGames && _vm.getGames.length > 0
                    ? [
                          'Total',
                          `${_vm.totalCurrentPlayers}`,
                          `${_vm.allServersCount}`,
                          `${_vm.total_coyns_earned}`,
                      ]
                    : null,"is-loading":_vm.getLoading,"no-title":true}})],1),_c('button-default',{staticClass:"games-table__view-all",style:(_vm.veryDarkBlueButton),attrs:{"color":'veryDarkBlue',"link":_vm.ALL_MY_GAMES_PAGE_NAME,"component-nav":true,"svg":true,"text":'View All',"name":'view_all_arrow',"svg-style":'width: 12px; fill: white; margin: auto 2px;'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }